import axios from 'axios'
import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from 'axios'
import { notify } from '@/utils/notify'
import router from '@/router'

export interface ApiResponse<T = any> {
  status: boolean
  code: number
  data: T
  message: string
}

const service: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL as string,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
  },
})

service.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = localStorage.getItem('token')
    if (token && config.headers && token != null && token != undefined) {
      config.headers["timtoken"] = token;
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

service.interceptors.response.use(
  (response: AxiosResponse<ApiResponse>) => {
    const res = response.data
    if ([2011, 2012, 2015].includes(res.code)) {
      localStorage.removeItem('token')
      notify.error('登录已失效，请重新登录')
      router.push('/login')
      return Promise.reject(new Error('token无效'))
    }
    if (res.code !== 200) {
      const errMsg = res.message || '请求失败'
      notify.error(errMsg)
      return Promise.reject(new Error(errMsg))
    }
    return response
  },
  (error) => {
    const message = error.response?.data?.message || error.message || '网络异常，请稍后重试'
    notify.error(message)
    return Promise.reject(error)
  },
)

export default service
